import { alpha } from '@mui/material/styles';

export default function Radio(theme) {
  const hoverBg = alpha(theme.palette.primary.main, 0.12);
  const idleColor = alpha(theme.palette.text.primary, 0.45);

  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: idleColor,
          transition: theme.transitions.create(['color', 'background-color'], {
            duration: theme.transitions.duration.shorter
          }),
          '&:hover': {
            backgroundColor: hoverBg
          },
          '&.Mui-checked': {
            color: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: hoverBg
            }
          }
        }
      }
    }
  };
}
